import { FC } from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import styles from './BeneficiariesList.module.scss';
import { TitleRow } from 'components/TitleRow';
import { BeneficiarItem } from 'ui/BeneficiarItem';
import { Link } from 'react-router-dom';
import type { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';
import { ItemTypes } from 'redux/Api/beneficiariesApi/type';

interface GroupsListTypes {
  data: ItemTypes[];
  intersectionRef?: UseInfiniteScrollHookRefCallback;
}

export const BeneficiariesList: FC<GroupsListTypes> = ({ data, intersectionRef }) => {
  const [parent] = useAutoAnimate({ duration: 300 });

  const dataTitle = [
    'id',
    'Статус',
    'PRO',
    'Наименование/сторона по договору',
    'Баланс',
    'Комиссия',
    'Холд',
    'Дата обновления',
  ];

  return (
    <div ref={parent} className={styles.root}>
      <TitleRow data={dataTitle} title='beneficiaries' />
      {data?.length ? (
        <div className={styles.window}>
          {data?.map((item: ItemTypes, index) => {
            const triggerIndex = Math.max(0, data.length - 15);
            const shouldAttachRef = index === triggerIndex;
            return (
              <Link
                key={item.id}
                ref={shouldAttachRef ? intersectionRef : undefined}
                to={`/beneficiaries/${item.id}`}>
                <BeneficiarItem group={item} />
              </Link>
            );
          })}
        </div>
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
